import React, { useContext, useEffect, useRef } from 'react';
import GlobalContext from 'hooks/contexts/GlobalContext';
import Questionnaire from 'components/form-wizards/Questionnaire';
import Wysiwyg from 'components/blocks/wysiwyg/Wysiwyg';
import ResponsiveImage from 'components/base/responsiveImage/ResponsiveImage';
import { BREAKPOINT_MAP } from 'consts';

function FullPageFormWrapper() {
  const {
    actions,
    questionnaire,
    windowSize: { currentBreakpoint },
    flags: { hasFormSidebar },
  } = useContext(GlobalContext);

  const stepsContainerRef = useRef(null);

  const shouldShowSteps = questionnaire && questionnaire.showSteps;
  const { content, image } = questionnaire?.sidebarContent || {};

  const getSidebarVisibility = () => {
    if (currentBreakpoint !== BREAKPOINT_MAP.DESKTOP.label) {
      return false;
    }

    return questionnaire && questionnaire.showSidebar;
  };

  const shouldShowSidebar = getSidebarVisibility();

  useEffect(() => {
    if (shouldShowSidebar !== hasFormSidebar) {
      actions.updateGlobalFlags({
        hasFormSidebar: shouldShowSidebar,
      });
      actions.updateGlobalRefs({
        stepsContainerRef,
      });
    }
    return () => {
      actions.updateGlobalRefs({
        stepsContainerRef: null,
      });
    };
  }, [questionnaire?.showSidebar, currentBreakpoint]);

  return (
    <div
      className={
        shouldShowSidebar
          ? `fullPageFormWrapper fullPageFormWrapper--hasSidebar`
          : 'fullPageFormWrapper'
      }
    >
      {shouldShowSidebar && (
        <aside className="fullPageFormWrapper__aside">
          {image && (
            <div className="fullPageFormWrapper__img">
              <ResponsiveImage images={image} />
            </div>
          )}
          <div className="fullPageFormWrapper__content">
            <Wysiwyg content={content} />
          </div>
          {shouldShowSteps && (
            <div
              className="fullPageFormWrapper__steps"
              ref={stepsContainerRef}
            />
          )}
        </aside>
      )}
      <div className="fullPageFormWrapper__questionnaire">
        <Questionnaire {...questionnaire} isFullPage />
      </div>
    </div>
  );
}

export default FullPageFormWrapper;
